import { render, staticRenderFns } from "./capacity.vue?vue&type=template&id=cb3d1012&scoped=true&"
import script from "./capacity.vue?vue&type=script&lang=js&"
export * from "./capacity.vue?vue&type=script&lang=js&"
import style0 from "./capacity.vue?vue&type=style&index=0&id=cb3d1012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3d1012",
  null
  
)

export default component.exports